import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Media } from '../../../../../theme/Media.js';
import { Loader } from '../../../../Elements/Loader/index.js';
import { formatNumber } from '../../../../utils/formatNumber.js';
import { PageInfoWrapper } from './styled.js';
export const PageInfo = memo(function PageInfo({ from, to, total, isLoading, dataTestId }) {
    const isMobile = useMediaQuery({ query: Media.xsMax });
    return (_jsxs(PageInfoWrapper, { "data-testid": dataTestId, children: [isLoading && _jsx(Loader, { cover: true }), !isMobile && (total ? `${formatNumber(from)} - ${formatNumber(to)} / ${formatNumber(total)}` : `0 / 0`), isMobile && (total ? `${formatNumber(from)}-${formatNumber(to)}/${formatNumber(total)}` : `0/0`)] }));
});
